import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Datagrid } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils';

export const DatagridStyled = styled(Datagrid)(() => ({
  borderRadius: '4px',
  '& .MuiTableCell-root': { padding: '16px', verticalAlign: 'middle' },
  '& .MuiTableCell-root:last-child': { ...getColumnStyle(126), textAlign: 'right' },
  '& .column-gateway': getColumnStyle(139),
  '& .column-merchantAccount': getColumnStyle(204),
  '& .column-settings': { ...getColumnStyle(204), paddingRight: '50px' },
  '& .column-subagent': getColumnStyle(100),
  '& .column-badge': { ...getColumnStyle(131) },
}));

export const GatewayRuleMappingDatagridEmpty = styled(Box)({
  border: '1px solid rgba(0, 0, 0, 0.12)',
  padding: '16px',
  borderRadius: '2px',
  fontSize: '14px',
  fontWeight: '500',
});
